import { Helmet } from 'react-helmet';

/**
 * Renders a schema.org object as a `<script type="application/ld+json">` block
 * in the document head via react-helmet. Schema-only — it never touches
 * canonical/OG tags (owned by other SEO work).
 */
export function JsonLd({ data }: { data: object }) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
